/**
 * 区分 checklistTemplateType（checklist_templates.checklist_template_type・monthly_checklist_tasks.checklist_template_type）
 * 出典：旧PCRM の種別（purchase 仕入先・sales 販売先）。274（10/13 ユーザー判断）で旧の 2 つに戻した（新だけの「自社社員」は廃止）
 * - 月次チェックリストの生成：全契約に販売先のタスク、仕入先がある契約には仕入先のタスクも作る（旧と同じ）
 * - 並びは旧の画面の順（仕入先 → 販売先）
 */
export const CHECKLIST_TEMPLATE_TYPE_VALUES = ['supplier', 'sales'] as const;

export type ChecklistTemplateType = (typeof CHECKLIST_TEMPLATE_TYPE_VALUES)[number];

export const CHECKLIST_TEMPLATE_TYPE_LABELS: Readonly<Record<ChecklistTemplateType, string>> = {
  supplier: '仕入先',
  sales: '販売先',
};
